import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';

import 'rxjs/add/operator/switchMap';

import { ProjectService } from '../services/project.service';
import {Project} from '../services/project.service';
import {Task} from '../services/project.service';


@Component({
  selector: 'project-detail-component',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.css'],
  providers: [ProjectService]

})
export class ProjectDetailComponent implements OnInit{

  constructor(
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  project:Project;
  task:Task;
  tasks = new Array();

  ngOnInit(): void {
    this.route.paramMap
      .switchMap((params: ParamMap) => this.projectService.getProject(+params.get('id')))
      .subscribe(project => this.project = project);
      this.projectService.getTasks().then(data => (this.tasks = data));
  }

  addTask() {
    this.tasks.push(

      { id: 1, project_id: 10, title: 'Add Task', description: '', date_start: '', date_end: '', owner:'Ollie', assigned: ['Bruce', 'Craig', 'Chris'] }

    )
  }

  goBack(): void {
      this.location.back();
  }



}



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/projects/project-detail.component.ts